import {combineReducers} from "redux";
import {createStore,applyMiddleware} from "redux";
import thunk from "redux-thunk";
import musiqiAletleri from './musiqialetleri.json'

const aletlerReducer = (state = musiqiAletleri) => {
    return state;
};



function basketReducerCart (state = [],action) {
    switch (action.type) {
        case "ADD_TO_CART":
            return [...state , action.payload] ;
        case "REMOVE_FROM_CART":
            return [...state.slice(0 , state.indexOf(action.payload)),...state.slice(state.indexOf(action.payload)+1)];

        default:
            return state;
    };
};

export const addToCart = (data) => {
    return {
        type : "ADD_TO_CART",
        payload : data
    };
};

export const deleteFromCart = (data) => {
    return {
        type : "REMOVE_FROM_CART",
        payload : data
    };
};

function countReducerCart (state = 0,action) {
    switch (action.type) {
        case "ADDCOUNT":
            return Number(Number(state) + Number(action.payload)).toFixed(2) ;
        case "REMOVECOUNT":
            return Number(Number(state) - Number(action.payload)).toFixed(2);

        default:
            return state;
    };
};

export const addCount = (data) => {
    return {
        type : "ADDCOUNT",
        payload : data
    };
};
export const removeCount = (data) => {
    return {
        type : "REMOVECOUNT",
        payload : data
    };
};
function countReducerWish (state = 0,action) {
    switch (action.type) {
        case "ADDCOUNTWISH":
            return Number(Number(state) + 1) ;
        case "REMOVECOUNTWISH":
            return Number(Number(state) - 1);

        default:
            return state;
    };
};

export const addCountWish = (data) => {
    return {
        type : "ADDCOUNTWISH",
        payload : data
    };
};
export const removeCountWish = (data) => {
    return {
        type : "REMOVECOUNTWISH",
        payload : data
    };
};

function basketReducerWish (state = [],action) {
    switch (action.type) {
        case "ADD_TO_WISHLIST":
            return [...state , action.payload] ;
        case "REMOVE_FROM_WISHLIST":
            return [...state.slice(0 , state.indexOf(action.payload)),...state.slice(state.indexOf(action.payload)+1)];

        default:
            return state;
    };
};

export const addToWish = (data) => {
    return {
        type : "ADD_TO_WISHLIST",
        payload : data
    };
};

export const deleteFromWish = (data) => {
    return {
        type : "REMOVE_FROM_WISHLIST",
        payload : data
    };
};

const reducers = combineReducers({
    aletlerReducer,
    basketReducerCart,
    basketReducerWish,
    countReducerCart,
    countReducerWish
});
const configureStore = () => {
    return createStore(reducers,applyMiddleware(thunk));
};

export function getMusiqiAletleri(sechilmishAlet){
    switch (sechilmishAlet) {
        case "GUITARS":
            return musiqiAletleri.filter(alet => alet['alet_novu'] === "GUITARS");
        case "PIANOS" :
            return musiqiAletleri.filter(alet => alet['alet_novu'] === "PIANOS");
        case "VIOLINS" :
            return musiqiAletleri.filter(alet => alet['alet_novu'] === "VIOLINS");
        case "DRUMS" :
            return musiqiAletleri.filter(alet => alet['alet_novu'] === "DRUMS");
        case "KIDS" :
            return musiqiAletleri.filter(alet => alet['alet_novu'] === "KIDS");
            
        default:
            return musiqiAletleri;
    }
};

export default configureStore;